// extracted by mini-css-extract-plugin
export default {"checkbox":"custom-icon-star_checkbox__kUjdN","outlineIcon":"custom-icon-star_outlineIcon__cAmQQ"};